export function isPageRouteObject(routeObject) {
    var _a;
    return 'handle' in routeObject && ((_a = routeObject.handle) === null || _a === void 0 ? void 0 : _a.type) === 'page';
}
export function isTabRouteObject(routeObject) {
    var _a;
    return 'handle' in routeObject && ((_a = routeObject.handle) === null || _a === void 0 ? void 0 : _a.type) === 'tab';
}
export function isTabsRouteObject(routeObject) {
    var _a;
    return 'handle' in routeObject && ((_a = routeObject.handle) === null || _a === void 0 ? void 0 : _a.type) === 'tabs';
}
